export const mixins = {
  data() {
    return {
      ready: false
    };
  },
  computed: {
    viewReady() {
      return this.ready;
    }
  },
  methods: {
    numbersOnly(evt) {
      // Use with @keydown event on input field
      const { key } = evt;
      const matches = key.match(/[0-9]/g);

      if (matches || key === 'Backspace' || key === 'Delete' || key === 'Enter' || key === 'Tab') {
        return true;
      }
      evt.preventDefault();
      return false;
    },

    threeNumbersOnly(evt) {
      // Use with @keydown event on input field
      const { key } = evt;
      const matches = key.match(/[0-9]/g);

      if (matches || key === 'Backspace' || key === 'Delete' || key === 'Enter') {
        const val = this.query + (matches ? key : '');
        if (val.length > 3) {
          evt.preventDefault();
          return false;
        }
        return true;
      }
      evt.preventDefault();
      return false;
    },

    dirtyInvalid(toCheck) {
      // Just trying to reduce code duplication
      return toCheck.$dirty && toCheck.$invalid;
    }
  }
};
